<template>
  <div class="ToolTip" :class="{'zeborne': isZeborne}" v-if="text !== ''">
    <span v-if="ToolText" :inner-html.prop="ToolText" class="ToolTip-smallText"></span>
    <span v-else class="ToolTip-text">?</span>

    <div class="ToolTip-present" :class="[classProps]">
      <div v-html="text" class="ToolTip-innerText"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import "@/components/ToolTip/ToolTip.scss";
export default {
  name: "ToolTip",

  props: {
    ToolText: {
      type: String,
      required:false
    },

    text: {
      type: [String, HTMLTextAreaElement],
      required: false,
    },

    classProps: {
      type: [String],
      required: false,
    },
  },

  computed: {
    ...mapGetters({ isZeborne: "isZeborne" }),
  },

};
</script>
